import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS = {
    DETAILS:
    {
        name: 'details',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SUBSCRIPTION_READ.name] })
    },
    CONTRACTS:
    {
        name: 'contracts',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.MERCHANT_CONTRACT_LIST.name] })
    },
    CONNECTIONS:
    {
        name: 'connections',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.POS_TERMINAL_LIST_EVENT_LOGS.name] })
    },
    TRANSACTIONS:
    {
        name: 'transactions',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.PAYMENT_LIST_TERMINAL_TRANSACTIONS.name] })
    },
    REMOTE_COLLECTIONS:
    {
        name: 'remote_collections',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.PAYMENT_LIST_TERMINAL_REMOTE_COLLECTIONS.name] })
    }
};

SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS.DEFAULT = SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS.DETAILS;

export default SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS;